import * as React from 'react';

import {ProductMarketField} from './product-market-field';
import type {MarketFieldInput} from './types';

import styles from './product-modal.module.css';

type Props = {
    marketFields: MarketFieldInput[];
    handleMarketFieldChange: (marketId: string, price: number, isAvailable: boolean) => void;
};

export function ProductMarketFieldArray(props: Props) {
    return (
        <div className={styles['product-market-field-array']}>
            {props.marketFields.map((marketField) => {
                return (
                    <ProductMarketField
                        key={marketField.market.id}
                        market={marketField.market}
                        price={marketField.price}
                        isAvailable={marketField.isAvailable}
                        onChange={(price, isAvailable) => {
                            props.handleMarketFieldChange(
                                marketField.market.id,
                                price,
                                isAvailable
                            );
                        }}
                    />
                );
            })}
        </div>
    );
}
